<script setup lang="ts">
import { computed } from 'vue';
import DateUtils from '@/utils/date-utils';

const props = defineProps<{
  interviewTypeDisplay: string;
  scheduleDateTs: string;
  jobTitle: string;
}>();

const formattedDate = computed(() => {
  return DateUtils.formatTimestamp(props.scheduleDateTs, 'MMMM D, YYYY, [at] h:mm A');
});
</script>

<template>
  <div
    class="flex h-6 w-full items-center bg-highlight-500 p-2"
    data-test="interview-scheduled-banner"
  >
    <p class="w-full text-center text-xs leading-[18px] text-white">
      <span class="font-bold">{{ interviewTypeDisplay }}</span>
      <span> — </span>
      <span class="font-bold">{{ formattedDate }}</span>
      <span> — </span>
      <span class="font-bold">{{ jobTitle }}</span>
    </p>
  </div>
</template>
